import React from "react";
import { CssBaseline, Typography, Container, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/help");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 500
  },
  route: {
    marginTop: theme.spacing(6),
    position: "relative",
    minHeight: "84vh"
  },
  bios: {
    flexGrow: 1
  },
  large: {
    width: theme.spacing(14),
    height: theme.spacing(14)
  }
}));

export default function Help() {
  const classes = useStyles();

  return (
    <div className={classes.route}>
      <CssBaseline />
      <Container maxWidth="md">
        <Typography variant="h4">Help</Typography>
        <Typography variant="h6" style={{ marginTop: 40 }}>
          Retail creative naming convention
        </Typography>
        <Typography variant="body1" paragraph="true">
          Please the indicate the expiration of retail offers (non-feed dynamic
          creative) in the Event/Offer/Promotion/Ad ID field. Note, this does
          not apply to dynamic retail as creative names are generic and the
          offers are rotated on the back end.
        </Typography>
        <Typography variant="body1">
          E.g. Retail offer that is valid an entire quarter:
        </Typography>
        <Typography variant="body1" paragraph="true">
          2019»GM Brand»»TEST»RET-E»APR»OLA»Q3»Static»US»ENG»v1»300x250»NA
        </Typography>
        <Typography variant="body1">
          E.g. Retail offer that is valid for a specific month:
        </Typography>
        <Typography variant="body1" paragraph="true">
          2019»GM
          Brand»»TEST»RET-E»APR»OLA»September»Static»US»ENG»v1»300x250»NA
        </Typography>
        <Typography variant="body1">
          E.g. Retail offer that is valid across multiple months, but not the
          entire quarter:
        </Typography>
        <Typography variant="body1" paragraph="true">
          2019»GM Brand»»TEST»RET-E»APR»OLA»September to
          October»Static»US»ENG»v1»300x250»NA
        </Typography>
        <Typography variant="body1">
          E.g. Retail offer that is valid for a specific time frame during a
          given month:
        </Typography>
        <Typography variant="body1" paragraph="true">
          2019»GM Brand»»TEST»RET-E»APR»OLA»September Ends
          9.10»Static»US»ENG»v1»300x250»NA
        </Typography>
        <Typography variant="h6" style={{ marginTop: 40 }}>
          Ad date process
        </Typography>
        <Typography variant="body1" paragraph="true">
          At this time, users cannot retroactively update an ad start/end date.
          Dates must be selected when associating the creative before sending to
          the ad server.
        </Typography>
        <Typography variant="body1" paragraph="true">
          For any creative that needs to end on a specific date (common for
          retail offers), under the Delivery Properties section, select the
          desired end date in the “End date and time” section for when the
          creative should stop delivering. Click the “Hard cut-off” option if
          there is a strict end date for a retail offer
        </Typography>
        <Typography variant="body1" paragraph="true">
          Please note: Users do not need to schedule start dates for a brand new
          campaign. For example, if you are working in a campaign that goes live
          11/1 and associating creative on 10/25, you do not need to set the ad
          start dates for 11/1. Reason being, the publisher will schedule the
          new campaign tags to go live on the required date.
        </Typography>
        <Typography variant="h6" style={{ marginTop: 40 }}>
          Default process
        </Typography>
        <Typography variant="body1" paragraph="true">
          Campaign-level defaults are required for all campaigns. For new
          campaigns, the first creative uploaded through Bart will automatically
          be assigned as the campaign-level default creative for each respective
          size. Default creative requires generic messaging and should not
          include any retail offers or any creative that requires flighting.
          Default creative must be a static image.
        </Typography>
        <Typography variant="body1" paragraph="true">
          Please follow the steps below FOR NEW CAMPAIGNS to accomplish this:
        </Typography>
        <Typography variant="body1" component="ol">
          <Typography variant="body1" component="li">
            Select your campaign in the campaign search bar
          </Typography>
          <Typography variant="body1" component="li">
            Filter on the first dimension
          </Typography>
          <Typography variant="body1" component="li">
            Click the “add creative” button and choose static Image
          </Typography>
          <Typography variant="body1" component="li">
            Follow the steps to assign a URL and name your creative with the
            proper taxonomy a. Rotation type, weight and delivery properties do
            not need to be adjusted for default
          </Typography>
          <Typography variant="body1" component="li">
            Submit the placements
          </Typography>
          <Typography variant="body1" component="li">
            Repeat steps 1-5 for all respective dimensions in the campaign
          </Typography>
          <Typography variant="body1" component="li">
            Repeat steps 1-5 for standard direction once the default creative is
            set
          </Typography>
        </Typography>
      </Container>
    </div>
  );
}
